import { TranslatePipe } from '../../filters/translate.pipe';
import { ListServicesComponent } from '../../components/list-services/list-services.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'history',
	templateUrl: './history.component.html',
	imports: [ CommonModule, TranslatePipe, ListServicesComponent, FormsModule ]
})
export default class HistoryView implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('history').then(() => { });
	}
	
}